import { HaNSearchInput } from "../search/HaNSearchInput";
import { HaNFloorSelector } from "./FloorSelector/FloorSelector";
import { HaNCalendarSyncTile } from "./HaNCalendarSyncTile";
import { HaNHeader } from "./HaNHeader";
import { HaNPage } from "./HaNPage";
import { HaNTabs } from "./HaNTabs";
import { HaNCarousel } from "./regions/Carousel";
import { HaNDetails } from "./regions/Details";
import { HaNFilterBar } from "./regions/FilterBar";
import { HaNList } from "./regions/List";
import { HaNMapStage } from "./regions/MapStage";
import { HaNTabsBar } from "./regions/TabsBar";

type HaNCompound = typeof HaNPage & {
  Page: typeof HaNPage;
  Header: typeof HaNHeader;
  CalendarSyncTile: typeof HaNCalendarSyncTile;
  TabsBar: typeof HaNTabsBar;
  Search: typeof HaNSearchInput;
  Tabs: typeof HaNTabs;
  FilterBar: typeof HaNFilterBar;
  List: typeof HaNList;
  MapStage: typeof HaNMapStage;
  FloorSelector: typeof HaNFloorSelector;
  Carousel: typeof HaNCarousel;
  Details: typeof HaNDetails;
};

export const HaN: HaNCompound = Object.assign(HaNPage, {
  Page: HaNPage,
  Header: HaNHeader,
  CalendarSyncTile: HaNCalendarSyncTile,
  TabsBar: HaNTabsBar,
  Search: HaNSearchInput,
  Tabs: HaNTabs,
  FilterBar: HaNFilterBar,
  List: HaNList,
  MapStage: HaNMapStage,
  FloorSelector: HaNFloorSelector,
  Carousel: HaNCarousel,
  Details: HaNDetails,
});
